module.exports = __webpack_public_path__ + "64e61d7d8297f8cac7647f9a42f3969f.png";